import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import actions from "redux-form/lib/actions";

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

const CustomDialog = (props) =>{
  const {
    classes,
    content,
    open,
    handleClose,
    customStyle,
    title,
    maxWidth,
    fullWidth,
    actions
  } = props;

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {title && (
          <DialogTitle id="max-width-dialog-title">Optional sizes</DialogTitle>
        )}
        <DialogContent>
          {content}
        </DialogContent>
        <DialogActions>
          {actions}
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

CustomDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.element
};

export default withStyles(styles)(CustomDialog);



// WEBPACK FOOTER //
// ./src/components/elements/customDialog.js